import React from "react";
import { FaRocket, FaUsers, FaLaptopHouse, FaGraduationCap } from "react-icons/fa";
import "./Careers.css";

const WhyJoinUs = () => {
  const benefits = [
    {
      icon: <FaRocket />,
      title: "Career Growth",
      desc: "Unlock new opportunities with continuous learning, mentorship, and promotions.",
    },
    {
      icon: <FaUsers />,
      title: "Great Culture",
      desc: "Work in a collaborative environment where ideas are valued and teamwork thrives.",
    },
    {
      icon: <FaLaptopHouse />,
      title: "Flexible Work",
      desc: "Enjoy remote, hybrid, and flexible schedules that support work-life balance.",
    },
    {
      icon: <FaGraduationCap />,
      title: "Learning & Development",
      desc: "Upskill with workshops, certifications, and hands-on experience.",
    },
  ];

  return (
    <section className="backdiv">
      <div>

          <h2 className="main-title">Why Join Vedastra</h2>
          <p className="main-text text-center">
            Join a workplace that values innovation, growth, and people-first culture.
          </p>
    

        <div className="whyjoin-grid">
          {benefits.map((item, index) => (
            <div className="whyjoin-card" key={index}>
                <div>
                    <div className="d-flex align-item-center justify-content-center">
              <div className="whyjoin-icon">{item.icon}</div></div>
              <h3 className="join-head">{item.title}</h3>
              <p className="join-desc">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyJoinUs;